@if (!isLogin) {
<mat-sidenav-container class="sidenav-container" autosize>

  @if (!isAdmisiones) {
  <mat-sidenav #drawer [class]="expanded ? 'sivenav mat-elevation-z8' : 'sidenav_true mat-elevation-z8'"
    [opened]="shouldSidenavBeOpened" mode="side">

    <mat-toolbar style="justify-content: center; position: sticky; top: 0; z-index: 1000;" class="miglm">
      <div [class]="expanded ? 'bottom-button' : 'bottom-button_2'">
        <button mat-icon-button (click)="expanded = !expanded" [matTooltip]="expanded ? 'Cerrar menú' : null"
          matTooltipPosition="right">
          <mat-icon>{{ expanded ? 'keyboard_double_arrow_left' : 'keyboard_double_arrow_right' }}</mat-icon>
        </button>
      </div>

      @if (!expanded) {
      <button mat-icon-button (click)="expanded = !expanded" [matTooltip]="!expanded ? 'Abrir menú' : null"
        matTooltipPosition="right">
        <mat-icon>menu_open</mat-icon>
      </button>
      }

      @if (expanded) {
      <a href="home"
        style="display: flex; align-items: center; cursor: pointer; position: relative; z-index: 2; text-decoration: none; color: inherit;"
        matTooltip="Página de inicio">
        <img style="cursor: pointer;" [matTooltip]="!expanded ? 'Abrir menú' : null" matTooltipPosition="right"
          src="https://w3miglm.blob.core.windows.net/com/wwwInternals/Logo%20GLM/logo_color_simbol.png" width="35px">
        <span style="margin-left: 8px; font-weight: bold;">MiGLM</span>
      </a>
      }
    </mat-toolbar>
    @if (!expanded) {
    <a href="home"
      style="display: flex; justify-content:center; align-items: center; cursor: pointer; position: relative; z-index: 2; text-decoration: none; color: inherit;"
      matTooltip="Página de inicio">
      <img style="cursor: pointer;"
        src="https://w3miglm.blob.core.windows.net/com/wwwInternals/Logo%20GLM/logo_color_simbol.png" width="35px">
    </a>
    }
    <nav-menu [drawerInstance]="drawer" [expanded]="expanded"></nav-menu>
  </mat-sidenav>
  }

  <mat-sidenav-content>

    <mat-toolbar [color]="theme() === 'light' ? 'primary' : 'secondary'"
      style="position: sticky; top: 0; z-index: 999; box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);">

      <div style="display: flex;">
        @if (!isAdmisiones) {
        <button mat-icon-button class="open-sidenav-button" (click)="toggleSidenav()" matTooltip="Menú Principal">
          <mat-icon [color]="theme() === 'light' ? 'primary' : 'secondary'">menu</mat-icon>
        </button>
        }

        @if (isAdmisiones) {
        <a [attr.href]="'/'">
          <button type="button" mat-icon-button matTooltip="Página de inicio">
            <mat-icon svgIcon="glm-logo"></mat-icon>
          </button>
        </a>
        }

        @if (topBarComponent) {
        <div class="header-mainInfo">
          <dynamic-bar class="index-title" [topBarData]="topBarComponent"></dynamic-bar>
        </div>
        }
      </div>

      <div>
        <button class="theme-switch" type="button" aria-label="cambio de color" mat-icon-button (click)="toggleTheme()"
          matTooltip="Cambio Tema">
          <mat-icon [color]="theme() === 'light' ? 'primary' : 'secondary'">
            {{ theme() === 'light' ? 'light_mode' : 'dark_mode' }}
          </mat-icon>
        </button>

        @if (verAyuda) {
        <a mat-icon-button aria-label="Ir a ayuda" [href]="urlAyuda" target="_new">
          <mat-icon [color]="theme() === 'light' ? 'primary' : 'secondary'" matTooltip="Página de Ayuda">
            help_outline
          </mat-icon>
        </a>
        }

        @if (!isAdmisiones) {
        <user-menu></user-menu>
        }
      </div>
    </mat-toolbar>

    <!-- 🔹 Barra global de ruta (mini) -->
    <!-- @if (currentPath?.length) {
    <mat-toolbar class="mini-breadcrumb" [color]="theme() === 'light' ? 'tertiary' : 'quaternary'">
      <div style="display: flex; align-items: center;">

        <mat-icon class="crumb-icon">route</mat-icon>

        <button mat-button class="crumb-home" (click)="navigateHome()">
          Home
        </button>

        @if (!(currentPath.length === 1 && currentPath[0] === 'home')) {

        <span class="sep">/</span>

        @for (seg of currentPath; track $index; let i = $index) {

        @if (!(i === 0 && seg === 'home')) {

     
        @if (i < currentPath.length - 1) { <button mat-button class="crumb-link" [routerLink]="buildLink(i)">
          {{ seg }}
          </button>
          }


          @if (i === currentPath.length - 1) {
          <span class="crumb-current">
            {{ seg }}
          </span>
          }

   
          @if (i < currentPath.length - 1) { <span class="sep">/</span>
            }
            }
            }
            }
      </div>
      <div>
        @if (!(currentPath.length === 1 && currentPath[0] === 'home')) {
        <button mat-icon-button class="crumb-close" color="error" matTooltip="Cerrar y volver atrás"
          (click)="goBackLevel()">
          <mat-icon>close</mat-icon>
        </button>
        }

      </div>
    </mat-toolbar>
    } -->

    <div>
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>

<custom-alert style="position: absolute; z-index: 10000;"></custom-alert>
<app-resource-viewer-modal origen="Admisiones" store="Process"></app-resource-viewer-modal>
} @else {
<router-outlet></router-outlet>
}